"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "prepareMetaUpdateQuery", {
    enumerable: true,
    get: function() {
        return prepareMetaUpdateQuery;
    }
});
function prepareMetaUpdateQuery(_) {
    return;
}
